function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmbrelloneSpiaggia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1006_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    style: {
      fill: "#EAD07D"
    },
    d: "M230,430C102.975,430,0,403.137,0,370s102.975-60,230-60s230,26.863,230,60 S357.025,430,230,430z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#D2BB71"
    },
    d: "M460,370H76.583L80,349.179l49.429-33.151C159.81,312.168,193.933,310,230,310 C357.026,310,460,336.863,460,370z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    style: {
      fill: "#8A7352"
    },
    d: "M339.908,195.865L82.448,368.533c-4.587,3.076-10.799,1.852-13.875-2.735 l-5.57-8.305c-3.076-4.587-1.852-10.799,2.735-13.875l257.46-172.669c4.587-3.076,10.799-1.852,13.875,2.735l5.57,8.305 C345.719,186.576,344.494,192.788,339.908,195.865z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1518_",
    style: {
      fill: "#FFA757"
    },
    d: "M395.856,369.055L184.198,53.459C257.587,4.24,364.462,34.988,422.91,122.138 S469.245,319.835,395.856,369.055z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1517_",
    style: {
      fill: "#D97948"
    },
    d: "M290.027,211.257l132.882-89.119c58.448,87.149,46.336,197.698-27.053,246.917 L290.027,211.257z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_222_",
    style: {
      fill: "#F49445"
    },
    d: "M334.586,277.698l-89.119-132.882c73.389-49.219,152.833-59.373,177.442-22.678 S407.975,228.479,334.586,277.698z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmbrelloneSpiaggia);
export default __webpack_public_path__ + "static/media/ombrellone_spiaggia.aee86394f9724bd82a3977ad373308f0.svg";
export { ForwardRef as ReactComponent };